var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#767B85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.796.027H1.204C.54.027 0 .567 0 1.23v7.226C0 9.12.54 9.66 1.204 9.66h13.592C15.46 9.66 16 9.12 16 8.456V1.23c0-.664-.54-1.204-1.204-1.204zm.172 8.43a.174.174 0 0 1-.172.172H1.204a.174.174 0 0 1-.172-.172V1.23c0-.093.08-.172.172-.172h13.592c.093 0 .172.079.172.172v7.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.824.37v.775a.68.68 0 0 1-.689.688H.38v1.032h.756c.95 0 1.72-.772 1.72-1.72V.37H1.825zm13.058 1.463a.68.68 0 0 1-.688-.688V.37H13.16v.774c0 .948.772 1.72 1.72 1.72h.775V1.833h-.774zM1.153 6.822H.379v1.032h.774a.68.68 0 0 1 .688.689v.774h1.032v-.774c0-.949-.772-1.72-1.72-1.72zm13.729 0c-.949 0-1.72.772-1.72 1.72v.775h1.032v-.774a.68.68 0 0 1 .688-.688h.774V6.822h-.774zm-4.745-4.029a2.88 2.88 0 0 0-2.051-.848 2.88 2.88 0 0 0-2.05.848 2.88 2.88 0 0 0-.849 2.05c0 .777.301 1.505.848 2.052a2.88 2.88 0 0 0 2.051.848 2.88 2.88 0 0 0 2.05-.848 2.88 2.88 0 0 0 .85-2.051 2.88 2.88 0 0 0-.85-2.051zm-.73 3.372a1.856 1.856 0 0 1-1.321.546c-.5 0-.97-.194-1.321-.546a1.855 1.855 0 0 1-.546-1.321c0-.5.194-.97.546-1.321a1.855 1.855 0 0 1 1.321-.546c.5 0 .97.194 1.321.546.352.352.546.82.546 1.32 0 .5-.194.97-.546 1.322z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimits);
export default __webpack_public_path__ + "static/media/limits.e13fb257039ba0cdcb41044879a0dbac.svg";
export { ForwardRef as ReactComponent };